import Enquiry from './Enquiry.provider';

export default Enquiry;
